import PostDialog from './PostDialog';

export default PostDialog;
